import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AuthenticatedUserFetchFailedAction = {
	type: 'AUTHENTICATED_USER_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AuthenticatedUserFetchFailedAction => ({
	type: 'AUTHENTICATED_USER_FETCH_FAILED',
	payload,
});
